"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Wrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Box = _interopRequireDefault(require("../Box"));
var _variants = require("./variants");
var _excluded = ["className", "color", "kind", "noMargin"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "wrapper": "y9JH-f",
  "primary": "AhArgK",
  "secondary": "o0zTpU",
  "inverse": "_71NBD5",
  "margin": "_1yZhpd"
};
var Wrapper = exports.Wrapper = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
    color = _ref.color,
    kind = _ref.kind,
    noMargin = _ref.noMargin,
    props = _objectWithoutProperties(_ref, _excluded);
  var parsedColor = kind || color || _variants.ProgressColor.PRIMARY;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], _extends({
    ref: ref,
    className: (0, _clsx["default"])(className, styles.wrapper, styles[parsedColor] || styles[_variants.ProgressColor.PRIMARY], !noMargin && styles.margin)
  }, props));
});
Wrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  kind: _propTypes["default"].string,
  noMargin: _propTypes["default"].bool
} : {};
var _default = exports["default"] = Wrapper;